import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actions as AuthActions } from "../../../../store/authRedux/actions";
import { actions as CommonActions } from "../../../../store/commonRedux/actions";
import { Avatar, Button } from "antd";
import {
  LoginOutlined,
  ApartmentOutlined,
  IdcardOutlined,
  PlusOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import styles from "./styles.module.css";
import { useQueryClient } from "react-query";
import { DownloadAppButton, EmptyState } from "../../../../components";

const SelectOrgForm = (props) => {
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const allOrganizations = useSelector(({ auth }) => auth.allOrganizations);
  /* سازمان‌هایی که این شماره در آن‌ها مشتری است، نه عضو. برای اکثر مردم خالی است؛
     همان کسی که هم جایی همکار است و هم جایی مشتری، اینجا هر دو را کنار هم
     می‌بیند — و این تنها جایی است که آن حالت هزینه‌ای دارد. */
  const customerOf = useSelector(({ auth }) => auth.customerOf);

  const resetCaches = () => {
    queryClient.invalidateQueries();
    queryClient.resetQueries();
  };

  const goToPanel = (org) => {
    resetCaches();

    dispatch(AuthActions.setPortalCustomer(null));
    dispatch(AuthActions.setOrganization(org));
    dispatch(AuthActions.setAuthenticated(true));
    /* همان اعلانی که هنگام جابه‌جایی بین سازمان‌ها هم می‌آید. اینجا برخلاف
       `switchOrganization` صفحه دوباره بار نمی‌شود، پس فقط گذاشتنش کافی است؛
       لایه‌ی اصلی موقع بالا آمدن نشانش می‌دهد. */
    if (org?.title) {
      dispatch(
        CommonActions.setVariables({
          orgSwitchNotice: { title: org.title, at: Date.now() },
        }),
      );
    }
  };

  const goToPortal = (membership) => {
    resetCaches();

    dispatch(AuthActions.setOrganization(membership.organization));
    dispatch(AuthActions.setPortalCustomer(membership));
    dispatch(AuthActions.setAuthenticated(true));
  };

  const hasAnyWorkspace =
    (allOrganizations?.length || 0) + (customerOf?.length || 0) > 0;

  return (
    <form className={styles.container}>
      <div className={`d-flex align-items-center gap-2 ${styles.page_title}`}>
        <LoginOutlined size={24} />
        ورود به فضای کاری
      </div>
      <div className={styles.formCard}>
        <div className={styles.cardIntro}>
          <div className={styles.step_ic}>
            <ApartmentOutlined />
          </div>
          <div>
            <p className={styles.step_title}>
              یک سازمان را برای ورود انتخاب کنید
            </p>
            <p className={styles.stepDescription}>
              پس از ورود نیز می‌توانید بین سازمان‌های خود جابه‌جا شوید.
            </p>
          </div>
        </div>

        <div className={styles.orgList}>
          {hasAnyWorkspace ? (
            <>
              {allOrganizations?.map((org) => (
                <div
                  className={styles.org_card}
                  key={org?.uuid || org?.id || org?.title}
                >
                  <div className="d-flex align-items-center gap-2">
                    <Avatar
                      size="large"
                      src={org?.avatar?.original_url}
                      icon={<TeamOutlined />}
                    />
                    <span className={styles.org_card_title}>{org?.title}</span>
                  </div>
                  <Button
                    icon={<LoginOutlined size={18} />}
                    onClick={() => goToPanel(org)}
                  >
                    ورود
                  </Button>
                </div>
              ))}

              {customerOf?.map((membership) => (
                <div className={styles.org_card} key={`customer-${membership.customer_id}`}>
                  <div className="d-flex align-items-center gap-2">
                    <Avatar
                      size="large"
                      src={membership.organization?.avatar?.original_url}
                      icon={<IdcardOutlined />}
                    />
                    <div className="d-flex flex-column">
                      <span className={styles.org_card_title}>
                        {membership.organization?.title}
                      </span>
                      {/* بدون این برچسب، دو ردیف با یک نام کنار هم می‌نشینند و
                          معلوم نیست کدام پنل است و کدام پرتال. */}
                      <Tag color="blue" bordered={false} style={{ width: "fit-content" }}>
                        مشتری
                      </Tag>
                    </div>
                  </div>
                  <Button
                    icon={<LoginOutlined size={18} />}
                    onClick={() => goToPortal(membership)}
                  >
                    ورود
                  </Button>
                </div>
              ))}
            </>
          ) : (
            <EmptyState
              compact
              icon={<ApartmentOutlined />}
              title="سازمانی برای نمایش نیست"
              description="هنوز عضو هیچ سازمانی نیستی یا دعوتی برات ثبت نشده."
            />
          )}
        </div>
        <Button
          className={styles.addButton}
          icon={<PlusOutlined />}
          disabled={(allOrganizations?.length || 0) >= 3}
          onClick={() => {
            navigate("/register", { replace: true });
          }}
        >
          {(allOrganizations?.length || 0) >= 3
            ? "حداکثر ۳ سازمان"
            : "افزودن سازمان جدید"}
        </Button>
      </div>
      <div className={styles.downloadWrap}>
        <DownloadAppButton />
      </div>
    </form>
  );
};

export default SelectOrgForm;
